import React from 'react'
import { render } from 'react-dom'
// import { Provider } from 'react-redux'
// import { createStore } from 'redux'
// import stylistApp from './editor/reducers'

import App from './editor/app/';
import Header from './editor/header/';
import Sidebar from './editor/sidebar/';


/* Import CSS */
import './index.scss'

/* Import plugins and 3-rd party libraries */
// import '../vendor/bootstrap-tooltip.js' - replaces with WP tooltips
// import '../vendor/iris.js' - replaced with crome color picker
// import '../vendor/nouislider.js' - imported using modules
// import '../vendor/contextmenu.js'

// import './get-default-value.js'
// import './globals'


// Document ready.
// document.addEventListener( 'DOMContentLoaded', function() {
document.addEventListener( 'readyToStart', function() {
	// Frame ready.
	render(
		<App />,
		document.getElementById( 'stylist-root' )
	)
} );



// WEBPACK FOOTER //
// ./dev/stylist_parent/index.js